import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  revenueSummary: {
    grossRevenue: 0,
    netRevenue: 0,
    averageRevenuePerStation: 0,
    partners: [],
  },

  uniqueCustomers: {
    totalUniqueCustomers: 0,
    partners: [],
  },

  sessionUptime: {
    totalUpTime: 0,
    uptimePercentage: 0,
    partners: [],
  },

  sessionSummary: {
    totalSessions: 0,
    totalKWh: 0,
    partners: [],
  },

  loading: false,
  error: null,
};

const GetAllBPRTwoReducer = createSlice({
  name: "getAllBPRTwo",
  initialState,

  reducers: {
    fetchBPRTwoRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchBPRTwoSuccess: (state, action) => {
      state.loading = false;

      const data = action.payload || {};

      state.revenueSummary = {
        grossRevenue: data.revenueSummary?.grossRevenue || 0,
        netRevenue: data.revenueSummary?.netRevenue || 0,
        averageRevenuePerStation:
          data.revenueSummary?.averageRevenuePerStation || 0,
        partners: data.revenueSummary?.partners || [],
      };

      state.uniqueCustomers = {
        totalUniqueCustomers:
          data.uniqueCustomers?.totalUniqueCustomers || 0,
        partners: data.uniqueCustomers?.partners || [],
      };

      state.sessionUptime = {
        totalUpTime: data.sessionUptime?.totalUpTime || 0,
        uptimePercentage: data.sessionUptime?.uptimePercentage || 0,
        partners: data.sessionUptime?.partners || [],
      };

      state.sessionSummary = {
        totalSessions: data.sessionSummary?.totalSessions || 0,
        totalKWh: data.sessionSummary?.totalKWh || 0,
        partners: data.sessionSummary?.partners || [],
      };
    },

    fetchBPRTwoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchBPRTwoRequest,
  fetchBPRTwoSuccess,
  fetchBPRTwoFailure,
} = GetAllBPRTwoReducer.actions;

export default GetAllBPRTwoReducer.reducer;